import { z } from "zod/v4";

import { CustomEventDtoSchema } from "../../../dtos/analytics-events/custom-events";

export const GetCustomEventsResponseBodySchema = z.object({
  customEvents: CustomEventDtoSchema.array(),
});

export type GetCustomEventsResponseBodyType = z.infer<
  typeof GetCustomEventsResponseBodySchema
>;
